module.exports = __webpack_public_path__ + "static/media/iap-whole.c5950159.png";